import React from 'react';
import { Radio } from 'lucide-react';

const STATUS_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'live', label: 'Live' },
  { key: 'upcoming', label: 'Upcoming' },
];

function GlobalFilters({
  liveStatus,
  setLiveStatus,
}) {
  return (
    <div className="global-filters">
      <div className="filter-group">
        <div className="filter-label">
          <Radio size={14} />
          <span>Status:</span>
        </div>
        <div className="filter-pills">
          {STATUS_OPTIONS.map(opt => (
            <button
              key={opt.key}
              className={liveStatus === opt.key ? 'active' : ''}
              onClick={() => setLiveStatus(opt.key)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GlobalFilters;
